import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import { Toaster } from "./components/ui/sonner";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Clients from "./pages/Clients";
import Missions from "./pages/Missions";
import Paiements from "./pages/Paiements";
import Analytics from "./pages/Analytics";
import Relances from "./pages/Relances";
import Utilisateurs from "./pages/Utilisateurs";
import Comptabilite from "./pages/Comptabilite";
import Depenses from "./pages/Depenses";
import ConformiteOHADA from "./pages/ConformiteOHADA";
import Licences from "./pages/Licences";
import Layout from "./components/Layout";
import { API_BASE } from "./lib/api";

export const API = API_BASE;

// Create axios instance with auth
export const apiClient = axios.create({
  baseURL: API,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const handleLogin = (userData, token) => {
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(userData));
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A0A0B] flex items-center justify-center">
        <div className="text-zinc-400">Chargement...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0A0A0B]">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          {/* Landing page (home) - accessible to everyone */}
          <Route 
            path="/" 
            element={
              user ? <Navigate to="/dashboard" replace /> : <Landing onLogin={handleLogin} />
            } 
          />
          <Route path="/login" element={<Login onLogin={handleLogin} />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout user={user} onLogout={handleLogout}>
                  <Routes>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/clients" element={<Clients />} />
                    <Route path="/missions" element={<Missions />} />
                    <Route path="/paiements" element={<Paiements />} />
                    <Route path="/depenses" element={<Depenses />} />
                    <Route path="/relances" element={<Relances />} />
                    <Route path="/analytics" element={<Analytics />} />
                    <Route path="/comptabilite" element={<Comptabilite />} />
                    <Route path="/conformite-ohada" element={<ConformiteOHADA />} />
                    <Route path="/utilisateurs" element={<Utilisateurs />} />
                    <Route path="/licences" element={<Licences />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
